<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
  >
    <g id="그룹_3755" data-name="그룹 3755" transform="translate(0 0)">
      <rect
        id="사각형_3733"
        data-name="사각형 3733"
        fill="#fff"
        width="18"
        height="18"
      />
      <path
        id="패스_1818"
        data-name="패스 1818"
        fill="#686868"
        d="M-1990.321,4658.545v16.307h-16.307v-16.307h16.307m.847-.847h-18v18h18v-18Z"
        transform="translate(2007.474 -4657.698)"
      />
    </g>
    <g id="그룹_3757" data-name="그룹 3757" transform="translate(2.49 6.381)">
      <g id="그룹_3756" data-name="그룹 3756">
        <path
          id="패스_1819"
          data-name="패스 1819"
          fill="#d34828"
          d="M-1977.874,4720.274h1.827c1.148,0,2.093.406,2.093,1.694,0,1.239-.959,1.785-2.058,1.785h-.609v1.729h-1.253Zm1.8,2.492c.609,0,.9-.287.9-.8s-.336-.707-.938-.707h-.511v1.5Z"
          transform="translate(1977.874 -4720.274)"
        />
        <path
          id="패스_1820"
          data-name="패스 1820"
          fill="#d34828"
          d="M-1936.655,4720.274h1.5a2.334,2.334,0,0,1,2.639,2.576,2.354,2.354,0,0,1-2.569,2.632h-1.568Zm1.421,4.2c.84,0,1.435-.385,1.435-1.624s-.595-1.582-1.435-1.582h-.168v3.206Z"
          transform="translate(1941.464 -4720.274)"
        />
        <path
          id="패스_1821"
          data-name="패스 1821"
          fill="#d34828"
          d="M-1892.915,4720.274h3.325v1.036h-2.072v1.142h1.778v1.043h-1.778v1.988h-1.253Z"
          transform="translate(1902.827 -4720.274)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
  },
};
</script>
